export default __webpack_public_path__ + "static/media/audit_assurance_and_compliance.83de9f9f.png";